
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // ニュースレター購読処理
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-green-900 text-white relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-24 border-2 border-white rounded-lg"></div>
        <div className="absolute bottom-20 right-20 w-24 h-20 border-2 border-white rounded-lg"></div>
        <div className="absolute top-1/3 right-1/4 w-16 h-12 border border-white rounded"></div>
      </div>

      <div className="relative z-10">
        {/* 上半分 */}
        <div className="px-6 pt-16 pb-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
              {/* ブランド・ニュースレターエリア */}
              <div className="lg:col-span-2">
                <div className="mb-6">
                  <h3 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                    町家珈琲
                    <span className="ml-2 text-amber-400">●</span>
                  </h3>
                </div>
                
                <form onSubmit={handleNewsletterSubmit} className="mb-6">
                  <div className="flex">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="メールアドレスを入力"
                      className="flex-1 px-4 py-3 bg-transparent border-2 border-white/30 rounded-l-lg text-white placeholder-white/70 focus:outline-none focus:border-amber-400 text-sm"
                      required
                    />
                    <button
                      type="submit"
                      className="w-12 h-12 bg-amber-600 hover:bg-amber-700 rounded-r-lg flex items-center justify-center transition-colors duration-300 cursor-pointer"
                    >
                      <i className="ri-notification-line text-white"></i>
                    </button>
                  </div>
                </form>
                
                <div className="text-lg leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  新着情報を<br />お届けします
                </div>
              </div>

              {/* ナビゲーションエリア */}
              <div className="lg:col-span-3">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                  <div>
                    <h4 className="font-semibold text-lg mb-4">メニュー</h4>
                    <ul className="space-y-2 text-sm">
                      <li>
                        <button onClick={() => scrollToSection('menu')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          珈琲
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('menu')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          軽食
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('menu')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          和菓子
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-4">店舗情報</h4>
                    <ul className="space-y-2 text-sm">
                      <li>
                        <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          アクセス
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          営業時間
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          予約
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-4">こだわり</h4>
                    <ul className="space-y-2 text-sm">
                      <li>
                        <button onClick={() => scrollToSection('features')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          自家焙煎
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          町家の趣
                        </button>
                      </li>
                      <li>
                        <button onClick={() => scrollToSection('features')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          季節の味
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-4">サポート</h4>
                    <ul className="space-y-2 text-sm">
                      <li>
                        <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          お問い合わせ
                        </button>
                      </li>
                      <li>
                        <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          よくある質問
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                          採用情報
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 下半分 */}
        <div className="border-t border-white/20 px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center">
              {/* 著作権表示 */}
              <div className="text-sm text-white/80 mb-4 md:mb-0">
                © 2025 町家珈琲 All rights reserved.
              </div>

              {/* ソーシャルメディア */}
              <div className="flex space-x-4 mb-4 md:mb-0">
                <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer">
                  <i className="ri-facebook-line text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer">
                  <i className="ri-twitter-line text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer">
                  <i className="ri-line-line text-white"></i>
                </a>
              </div>

              {/* プライバシーポリシー・クイックリンク */}
              <div className="flex items-center space-x-4">
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  プライバシーポリシー
                </a>
                <span className="text-white/40">|</span>
                <a href="https://readdy.ai/?origin=logo" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
